module.exports = __webpack_public_path__ + "media/img/home/product/mobile/product2-4c1d518d47c4059001ee27ef65ca8467.svg";